module.exports = __webpack_public_path__ + "static/media/01.d1c7bd7b.png";